export default {
	"requestInvite.success.title": "Einladung angefragt",
	"requestInvite.success.text":
		"Bitte schauen Sie in Ihrem E-Mail Posteingang nach!",
	"requestInvite.submit.label": "Einladung anfragen",
} as const;
